import * as actionTypes from './userActionTypes';

const initialState = {
    loggedIn: true,   
    username: ""
}

export default function user(state = initialState, action) {
    switch (action.type) {
        case (actionTypes.LOGIN):
            if (state.username !== action.username) {  
                return Object.assign({}, state, { 
                    loggedIn: true,                   
                    username: action.username,
                });
            }
            return state;
        case (actionTypes.LOGOUT):
            if (state.loggedIn === true) {
                return Object.assign({}, state, { loggedIn: false, username: "" });
            }
            return state;
        default:
            return state;
    }
}